export const initialTouchedForAll = <T,>(initialValues: Record<string, T>): Record<string, true> => {
  return Object.keys(initialValues).reduce(
    (attrs, key) => ({
      ...attrs,
      [key]: true,
    }),
    {}
  )
}
